import { StanTag } from '@/components';
import { ProductPayment } from '../types/transactionTypes';
import { STAN_TAG_PRESETS } from '@/lib';

export function TransactionGeneralDetails({
    paymentData,
    onCustomerClick,
    onProductClick,
}: {
    paymentData: ProductPayment;
    onCustomerClick: () => void;
    onProductClick: () => void;
}) {
    const customerName = paymentData.full_name;
    const customerEmail = paymentData.email;
    const productType = paymentData.product_type;
    const productSubtype = paymentData.subType;
    const productName = paymentData.data.title;
    const paymentGateway = paymentData.payment_gateway;
    const userFanId = paymentData.user_fan_id;

    let paymentGatewayName: string = paymentGateway;
    const paymentDate = paymentData.date;
    if (paymentGateway === 'stripe' || paymentGateway === 'stripe-checkout') paymentGatewayName = 'stripe';
    else if (paymentGateway === 'manual-access-granted') paymentGatewayName = 'access granted';

    const productTagBGColor = STAN_TAG_PRESETS?.['product']?.[productType]?.backgroundColor;
    const productTagTextColor = STAN_TAG_PRESETS?.['product']?.[productType]?.textColor;
    const productTagLabel = STAN_TAG_PRESETS?.['product']?.[productType]?.label ?? 'Product';

    const productTagStyle =
        productTagBGColor && productTagTextColor
            ? { backgroundColor: productTagBGColor, color: productTagTextColor }
            : undefined;

    return (
        <div className='flex w-full flex-col flex-wrap items-start gap-4 p-0 md:flex-row'>
            <div className='flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col'>
                <div className='text-gray text-sm font-semibold'>Name</div>
                <div className={`ml-auto md:ml-0 ${userFanId ? 'cursor-pointer' : ''}`} onClick={onCustomerClick}>
                    {customerName}
                </div>
            </div>
            <div className='md:border-l-neutral-soft flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Email</div>
                <div className='ml-auto md:ml-0'>{customerEmail}</div>
            </div>
            <div className='md:border-l-neutral-soft flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Product</div>
                <div className='ml-auto flex items-start md:ml-0'>
                    <StanTag label={productTagLabel} style={productTagStyle} className='mr-3' />
                    {productSubtype && (
                        <StanTag
                            label={productSubtype}
                            style={{
                                backgroundColor: 'var(--stan-gray-primary-color)',
                                color: 'var(--stan-text-dark-color)',
                            }}
                        />
                    )}
                    &nbsp;
                    <div className={`${paymentData.page_id ? 'cursor-pointer' : ''}`} onClick={onProductClick}>
                        {productName}
                    </div>
                </div>
            </div>
            <div className='md:border-l-neutral-soft flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Method</div>
                <div className='ml-auto capitalize md:ml-0'>{paymentGatewayName}</div>
            </div>
            <div className='md:border-l-neutral-soft flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Date</div>
                <div className='ml-auto md:ml-0'>{paymentDate}</div>
            </div>
        </div>
    );
}
